import alt          from '../alt/alt.js';
import DataActions  from '../actions/DataActions.js';

class DataStore {
  constructor() {
    this.data = {};

    this.bindListeners({
      // Listen to the getSuccess() in DataActions.js
      handleSuccess: DataActions.GET_SUCCESS
    });

    this.exportPublicMethods({
      getAll:         this.getAll,
      getAllPages:    this.getAllPages,
      getAllPosts:    this.getAllPosts,
      getAllProjects: this.getAllProjects,
      getPageBySlug:  this.getPageBySlug,
      getProjectBySlug:  this.getProjectBySlug,
      getPostBySlug:   this.getPostBySlug
    });
  }

  // Store data returned by getSuccess() in DataActions.js
  handleSuccess(data) {
    this.setState({ data });
  }

  // Returns all pages and posts
  getAll() {
    return this.getState().data;
  }

  // Returns all Pages
  getAllPages() {
    return this.getState().data.pages;
  }

  // Returns all Posts
  getAllPosts() {
    return this.getState().data.posts;
  }

  // Returns all Projects
  getAllProjects() {
    return this.getState().data.projects;
  }

  // Returns a Page by provided slug
  getPageBySlug(slug){
    const pages = this.getState().data.pages;

    return pages[Object.keys(pages).find((page, i) => {
        return pages[page].slug === slug;
    })] || {};
  }

  getProjectBySlug(slug){
    const projects = this.getState().data.projects;
    return projects[Object.keys(projects).find((project, i) => {
        return projects[project].slug === slug;
    })] || {};
  }

  getPostBySlug(slug){
    const posts = this.getState().data.posts;
    return posts[Object.keys(posts).find((post, i) => {
        return posts[post].slug === slug;
    })] || {};
  }
}

export default alt.createStore(DataStore, 'DataStore');



// WEBPACK FOOTER //
// ./src/scripts/flux/stores/DataStore.js